/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S5_Li2Inputs */

const en_guide_json_rest_api_s5_li2 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always set the <strong>Content-Type: application/json</strong> header`)
};

const ko_guide_json_rest_api_s5_li2 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`항상 <strong>Content-Type: application/json</strong> 헤더를 설정하세요`)
};

const ja_guide_json_rest_api_s5_li2 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常に<strong>Content-Type: application/json</strong>ヘッダーを設定してください`)
};

/**
* | output |
* | --- |
* | "Always set the <strong>Content-Type: application/json</strong> header" |
*
* @param {Guide_Json_Rest_Api_S5_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s5_li2 = /** @type {((inputs?: Guide_Json_Rest_Api_S5_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S5_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s5_li2(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s5_li2(inputs)
	return ja_guide_json_rest_api_s5_li2(inputs)
});